/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { WoundViewModel } from './WoundViewModel'; 

export function getWoundOptions(woundId: string, onSuccess?: (result: WoundViewModel) => void) {
	return queryOptions({
		queryKey: ['wound', woundId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/woundmanagement/queries/getwound/' + woundId;
			const resp = await axios.get<WoundViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(woundId)
	});
}